import React from 'react'
import './css/Brand.css'
import brand_banner from '../Components/Assets/brand-banner.png'
import radius_logo from '../Components/Assets/radius-windsheild-logo.png'
import ursa_logo from '../Components/Assets/ursa-logo.png'
import viviana_logo from '../Components/Assets/viviana-logo.png'
import hideamic_logo from '../Components/Assets/Hide-a-mic_BrandLogo.png'

const Brand = () => {
  return (
    <div className='brand'>
      <div className="brand-banner">
        <img src={brand_banner} alt="" />
      </div>
      <hr />
      <div className="dealer-template">
          <div className="dealer-card">
        <div className="dealer-logo"><img src={hideamic_logo} alt="" /></div>
        <p>Hide-a-mic MCS India</p>
      </div>
      <div className="dealer-card">
        <div className="dealer-logo"><img src={radius_logo} alt="" /></div>
        <p>Radius Windshield India</p>
      </div>
      <div className="dealer-card">
        <div className="dealer-logo"><img src={ursa_logo} alt="" /></div>
        <p>Ursa Straps India</p>
      </div>
      <div className="dealer-card">
        <div className="dealer-logo"><img src={viviana_logo} alt="" /></div>
        <p>Viviana Straps India</p>
      </div>
      
      </div>
    
    </div>
  )
}

export default Brand